import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { AppInsightsService } from 'src/app/services/app-insights/appinsights.service';
import { MemberService } from 'src/app/services/member/member.service';
import { ICommandCancelConfig } from 'src/app/services/task/command/command.models';
import { SystemEvaluatorService } from 'src/app/services/task/system-evaluator/system-evaluator.service';
import { Member } from '../../models/member';
import { InterviewDefaultDataProviderService } from '../../shared/interview-new/instances/data-providers/interview-default-data-provider.service';
import { TenantService } from '../tenant/tenant.service';
import { RoleService } from '../user/role.service';
import { UserService } from '../user/user.service';


export const interviewRpcDataProviderToken = 'interview-rpc-data-provider';

@Injectable()
export class InterviewRpcDataProviderService extends InterviewDefaultDataProviderService {

    constructor(private store: Store,
        private memberService: MemberService,
        private systemEvaluatorService: SystemEvaluatorService,
        private appInsightsService: AppInsightsService,
        private tenantService: TenantService,
        private userService: UserService,
    ) {
        super();
    }

    async generateContextData(contextData: any, input?: any) {
        // wait until member get initialized
        await firstValueFrom(this.memberService.initialized$.pipe(filter(_ => _), first()));

        const { memberContext } = this.memberService.getCurrentTelephonyContext();

        if (memberContext?.telephonyRecordId == null) {
            try {

                const memberHash = this.memberService.memberSync?.$memberHash;
                const memberId = this.memberService.memberSync?.id;

                this.appInsightsService.logException(new Error('The memberContext is null in interview-rpc-data-provider.service.ts'), 'interview-rpc-data-provider.service.ts', this.memberService.getCurrentTelephonyContext(), 'interview-rpc-data-provider.service.ts')
            } catch (error) {
                this.appInsightsService.logException(error, 'interview-rpc-data-provider.service.ts')
            }
        }
        return {
            ...(await super.generateContextData(contextData)),
            Member: this.store.selectSnapshot<Member>(MemberService.member),
            entityId: contextData.entityId || memberContext?.telephonyRecordId,
            direction: this.systemEvaluatorService.screener.direction || 'MANUAL',
            tenantDisplayName: this.tenantService.findTenantByIdSync(this.memberService.tenantIdSync)?.displayName,
            userFirstName: this.userService.userSync.firstName,
            userLastName: this.userService.userSync.lastName,
            role: this.store.selectSnapshot<string>(RoleService.currentRoleName),
            user: this.userService.userSync.uniqueName,            
        };
    }

    processCommandCancel(): Promise<any> {
        const stopChain = ['INBOUND', 'OUTBOUND'].some(_ => _ === this.systemEvaluatorService.screener.direction) === false;

        if (stopChain) {
            this.memberService.setOnCall(false);
            return Promise.resolve({ stopChain } as ICommandCancelConfig);
        }

        return Promise.resolve(null);
    }
}
